__webpack_require__.p = "https://edo.vchasno.ua/cloud-cgi/static/edo-static-files-prd/";